import { render, staticRenderFns } from "./PlacementsEndComponentReviewGraduateCommentsAdmin.vue?vue&type=template&id=277e2486&"
import script from "./PlacementsEndComponentReviewGraduateCommentsAdmin.vue?vue&type=script&lang=js&"
export * from "./PlacementsEndComponentReviewGraduateCommentsAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports